import api from '@pray/shared/utils/api';

import type { SeriesTag } from './getSeriesTags';

export interface AddSeriesTagResponse {
  data: SeriesTag[];
}

export interface AddSeriesTagParams {
  artistId: string;
  seriesId: string;
  tagId?: string;
  tagName?: string;
  color?: string;
}

/**
 * Add a tag to a content series
 * Can add an existing tag by ID or create a new tag by name
 */
export async function addSeriesTag({
  artistId,
  seriesId,
  tagId,
  tagName,
  color,
}: AddSeriesTagParams): Promise<AddSeriesTagResponse> {
  const body: Record<string, string> = {};

  if (tagId) {
    body.tag_id = tagId;
  }
  if (tagName) {
    body.tag_name = tagName;
  }
  if (color) {
    body.color = color;
  }

  const url = `/web/studio/artists/${artistId}/content-series/${seriesId}/tags`;
  const response = await api.executePostRequest<AddSeriesTagResponse>(url, body);
  return response.data;
}
